import { useQuery } from '@tanstack/react-query';
import { useCurrentAuthSession } from '@/context/AuthContext';
import { fetchUnitData } from './useUnitData';
import { ProductType } from '../../../types/ProductType';
import {
  ProductCapabilities,
  productConfigs,
} from '../../../const/product-config';
import { useUserInfo } from './useUserInfo';

/**
 * Hook to get the product configuration of a unit
 * @param unitId - The ID of the unit to get the product configuration for
 * @returns The product configuration of the unit and loading state
 */
export const useProductConfig = (unitId: string | undefined) => {
  const { user } = useCurrentAuthSession();
  const { data: userInfo } = useUserInfo();

  const { data: unit, isLoading } = useQuery({
    queryKey: ['units', unitId],
    queryFn: async () => fetchUnitData(unitId!, user?.uid, userInfo?.customer),
    enabled: Boolean(unitId),
  });

  const productType = (unit?.productType as ProductType) ?? ProductType.Generic;
  const config = productConfigs[productType];

  return {
    config,
    isLoading,
    productType,
  } satisfies {
    config: ProductCapabilities;
    isLoading: boolean;
    productType: ProductType;
  };
};
